import { useEffect, useRef, useState } from 'react'

/**
 * Contract B regions: render the skeleton while this is true, nothing while
 * loading and false (Loading card: hold ~300ms; do not show one below that).
 *
 * Becomes true once `loading` has lasted `delayMs`, and stays true for at
 * least `minMs` after that, so a fast response never flashes a skeleton.
 */
export function useSkeletonDelay(
  loading: boolean,
  delayMs = 300,
  minMs = 300,
): boolean {
  const [shown, setShown] = useState(false)
  const shownAt = useRef(0)

  useEffect(() => {
    if (loading && !shown) {
      const timer = setTimeout(() => {
        shownAt.current = Date.now()
        setShown(true)
      }, delayMs)
      return () => clearTimeout(timer)
    }
    if (!loading && shown) {
      const remaining = Math.max(0, shownAt.current + minMs - Date.now())
      const timer = setTimeout(() => setShown(false), remaining)
      return () => clearTimeout(timer)
    }
  }, [loading, shown, delayMs, minMs])

  return shown
}
